import React from 'react';
import { Field, useFormikContext } from 'formik';

import { FormErrorUI, FormLabelUI, AutoCompleteSelectUI } from '../Interface';

const CompanyBreakFields = ({ viewField, selectedValues, autocompleteOptions }) => {
  const { values, setFieldValue, validateField, errors } = useFormikContext();

  return (
    <div className="grid grid-cols-4 gap-x-4 gap-y-4 mx-4 mb-5">
      <div className="col-span-4 md:col-span-2">
        <Field
          type="autocomplete"
          name="companyLocationId"
          component={AutoCompleteSelectUI}
          fullWidth
          label={<FormLabelUI text="Telephely" />}
          variant="standard"
          helperText={<FormErrorUI message={errors.companyLocationId} />}
          onChange={(_e, newVal) => {
            setFieldValue('companyLocationId', newVal?.value ?? null).then(() => {
              validateField('companyLocationId');
            });
          }}
          disabled={viewField}
          InputLabelProps={{ shrink: values.companyLocationId !== '' }}
          selectedValue={values.companyLocationId}
          selectedLabelValue={selectedValues?.companyLocation?.name}
          dataset={autocompleteOptions.companyLocation}
        />
      </div>
    </div>
  );
};

export default CompanyBreakFields;
